import { HostPageDetailsQuery } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Button, Col, Container, Row } from 'react-bootstrap';

type HostTripsCardProps = {
  trips: HostPageDetailsQuery['hostByURL']['trips']['items'];
};

export function HostTripsCard({ trips }: HostTripsCardProps) {
  return (
    <Container className="mx-auto">
      <Row>
        <h3 aria-level={3} data-testid="host-trips-header">
          Trips
        </h3>
      </Row>
      <Row>
        {trips.map((trip) => {
          return (
            <Col className="p-2" key={trip.id} sm="12">
              <h4 aria-level={4}>{trip.title}</h4>
              <Row>
                <Col className="lead" title="Trip Details">
                  {trip.description}
                </Col>
              </Row>
              <Row>
                <Col className="pt-3 pb-3">
                  <Link
                    href="/trips/[tripUrl]"
                    as={`/trips/${trip.urlSlug}`}
                    passHref
                    legacyBehavior
                  >
                    <Button
                      as="a"
                      title="View Trip"
                      role="button"
                      variant="primary"
                    >
                      View Trip
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
